<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo bold">Registros</span>
                </div>
                <div class="col-6 col-md-6" v-if="this.$store.state.user.user_level == 1">
                  <router-link class="btngris float-right" to="/registro">
                    Nuevo registro
                  </router-link>
                </div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12" v-if="this.data != null">
                    <v-client-table
                      :columns="columns"
                      v-model="data"
                      :options="options"
                    >
                      <a slot="status" slot-scope="props">
                        <span v-if="props.row.status == 1">Activa</span>
                        <span class="rojo" v-if="props.row.status == 0"
                          >Baja</span
                        >
                      </a>

                      <router-link
                        slot="uri"
                        slot-scope="props"
                        :to="'/registro/' + props.row.id"
                        class="text-center negro"
                      >
                        <i class="fas fa-eye"></i> Ver
                      </router-link>

                      <!-- <router-link
                        slot="baja"
                        slot-scope="props"
                        :to="'/dashboard/alumnos/baja/'+props.row.id"
                        class="text-center"
                      >
                        <i class="fas fa-times"></i>
                      </router-link>

                      <router-link
                        slot="bloqueo"
                        slot-scope="props"
                        :to="'/dashboard/alumnos/bloqueo/'+props.row.matricula"
                        class="text-center"
                      >
                        <i class="fas fa-lock-open"></i>
                      </router-link> -->

                      <!-- <div slot="grupos" slot-scope="props">
                        <div v-for="item in props.row.grupos" v-bind:key="item">
                          <router-link
                            :to="'/dashboard/alumnos/grupos/'+item.id_grupo+'/'+props.row.matricula"
                          >
                            {{item.nombre}}
                          </router-link>
                        </div>
                      </div> -->

                      <!-- <div slot="child_row" slot-scope="props">
                      <a
                        class="pr-5"
                        target="_blank"
                        :href="baseurl+'uploads/'+props.row.img_qr"
                      >
                        <img
                          :src="baseurl+'uploads/'+props.row.img_qr"
                          alt="qr"
                          width="100"
                        />
                      </a>

                      <a
                        target="_blank"
                        :href="baseurl+'uploads/'+props.row.img_ticket"
                      >
                        <img
                          :src="baseurl+'uploads/'+props.row.img_ticket"
                          alt="qr"
                          width="100"
                        />
                      </a>
                      </div>-->

                      <div
                        slot="name"
                        slot-scope="{
                          row,
                          update,
                          setEditing,
                          isEditing,
                          revertValue,
                        }"
                      >
                        <span @click="setEditing(true)" v-if="!isEditing()">
                          <a>{{ row.name }}</a>
                        </span>
                        <span v-else>
                          <input type="text" v-model="row.name" />
                          <button
                            type="button"
                            class="btn btn-info btn-xs"
                            @click="
                              update(row.name);
                              setEditing(false);
                            "
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            class="btn btn-default btn-xs"
                            @click="
                              revertValue();
                              setEditing(false);
                            "
                          >
                            Cancel
                          </button>
                        </span>
                      </div>
                    </v-client-table>
                  </div>
                </div>

                <span
                  class="loading"
                  v-bind:class="{ active: this.$store.state.loading }"
                >
                  <img
                    src="../assets/imgs/DualRing-1.1s-28px.svg"
                    alt="loading"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style>
@import "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
</style>


<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      tiposervicio: "",
      columns: [
        "uri",
        "status",
        "timestamp",
        "contratante",
        "no_poliza",
        "no_certificado",
        "valor_factura",
        "prima_neta",
        "prima_total",
        "equipamiento_adicional",
        "razon_social",
        "nombre",
        "apellido_paterno",
        "apellido_materno",

        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 25,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          timestamp: "Fecha",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          nombre: "Nombre",
          razon_social: "Razón Social",
          apellido_paterno: "Ap. Paterno",
          apellido_materno: "Ap. Materno",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [
          "timestamp",
          "contratante",
          "no_poliza",
          "no_certificado",
          "status",
          "nombre",
          "razon_social",
          "apellido_paterno",
          "apellido_materno"
        ],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    AOS.init();

    console.log({user: this.$store.state.user});


    this.consulta();

    // this.data = [
    //   {
    //     id: 34,
    //     fecha: '01/07/2021',
    //     contratante: "Fulano Pérez",
    //     email: "fperez@gmail.com",
    //     no_poliza: "CPM210000000100",
    //     no_certificado: "CPM21000000010000001",
    //     detalle: true
    //   },
    //    {
    //     id: 35,
    //     fecha: '01/07/2021',
    //     contratante: "Mengano Pérez",
    //     email: "mperez@gmail.com",
    //     no_poliza: "CPM210000000200",
    //     no_certificado: "CPM21000000010000002",
    //     detalle: true
    //   },

    // ];
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        admin_id: this.$store.state.user.admin_id,
        user_id: this.$store.state.user.id,
        user_level: this.$store.state.user.user_level
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-registros.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        /*nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        tel: this.tel,
        no_ticket: this.no_ticket,
        sede: this.sede*/
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(userData));

      this.$http
        .post(
          vm.$store.state.baseurl + "alumnos/consulta-alumno.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              this.registro = 1;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      this.$router.push("dashboard");
    },
  },
};
</script>

